import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, HostListener, Inject, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PhoneNumbersEnum } from '@app/core/enums/phone-numbers.enums';
import { WINDOW } from '@inshared/shared/util';
import { AppRoutesEnum } from '@app/routes';
import { PanelExpandableComponent } from '@app/shared/ux/panel-expandable/panel-expandable.component';

@Component({
    selector: 'ins-report-claim-button',
    templateUrl: 'report-claim-button.component.html',
    styleUrls: ['./report-claim-button.component.scss'],
})
export class ReportClaimButtonComponent {
    @ViewChild(PanelExpandableComponent, { static: true }) child: PanelExpandableComponent;

    @Input() labelArrow: boolean = true;

    public labelArrowVisible: boolean = true;
    public phoneNumbersEnum = PhoneNumbersEnum;
    public appRoutesEnum = AppRoutesEnum;

    // eslint-disable-next-line no-useless-constructor
    constructor(
        private myElement: ElementRef,
        private router: Router,
        @Inject(DOCUMENT) private document: Document,
        @Inject(WINDOW) private window: Window
    ) {}

    @HostListener('window:scroll', ['$event']) onScrollEvent(): void {
        const scrollY = this.window.scrollY;
        const headerHeight = this.document.querySelector('.header').clientHeight;
        const headerBreadcrumb = this.document.querySelector('.breadcrumb').clientHeight;
        const h1Height = this.document.querySelector('h1').clientHeight;

        this.labelArrowVisible = scrollY <= headerHeight + headerBreadcrumb + h1Height;
    }

    public navigateToClaim(): void {
        this.document.location.href = AppRoutesEnum.OldClaimFunnel;
    }
}
